import reduceReducers from 'reduce-reducers';

//Siblings reducers
import bookingAMC360Reducer from './booking-amc360-reducer';

export default reduceReducers(bookingAMC360Reducer);
